import { FunctionComponent } from 'react';
import GenericIcons from '../../../components/generics/GenericIcons';
import '../../../css/PublicAboutUsPage.css';

// Logos en grilla: recortes de img/companiesLogos.png más la co-marca oficial UAI | CENTRA.
const companyLogos = ['acesol', 'ministerio', 'sec', 'uai-centra', 'empresas'];

const Component06: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-six-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>Impacto en el sector y Logros</h2>
        <small>Ecosistema</small>
      </div>

      <p className='public-about-us-page-text vdr-about-lead'>
        A lo largo de tan solo unos meses, VisiónDERRED ha logrado marcar una diferencia, mediante
        la colaboración a través de seis mesas de trabajo con diversas entidades del sector
        energético para ofrecer herramientas adaptadas a las necesidades de cada cliente,
        maximizando el valor que les proporcionará la plataforma. Entre las entidades que formaron
        parte del éxito de la primera fase del proyecto se encuentran representantes de empresas
        eléctricas como SAESA, ENEL, Chilquinta y CGE, el gremio de los desarrolladores de proyectos
        fotovoltaicos (ACESOL), la entidad reguladora (SEC) y el ministerio de energía y medio
        ambiente (MEN)
      </p>
      <figure className='public-about-us-page-logo-companies-container' aria-hidden='true'>
        {companyLogos.map((logo) => (
          <div key={logo} className='vdr-about-logo-cell'>
            <span className={`vdr-about-logo vdr-about-logo--${logo}`} />
          </div>
        ))}
      </figure>
      <div className='vdr-about-split'>
        <p className='public-about-us-page-text'>
          Otro logro en el contexto del proyecto fue la presentación de los avances en el
          desarrollo de las herramientas que se encuentran contenidas en la plataforma en la
          prestigiosa conferencia ISGT Europe, organizada por la IEEE y realizada en octubre del año
          2024 en Croacia. Evento en el cual se recibió comentarios alentadores y otras experiencias
          como la de Australia nos inspiraron a continuar desarrollando herramientas que generen
          valor a la industria de la distribución eléctrica.
        </p>
        <figure className='public-about-us-page-conference-image-container'>
          <GenericIcons
            icon='conference'
            imageStyle={{
              width: '100%',
              aspectRatio: '4 / 3',
              objectFit: 'cover',
              objectPosition: '50% 32%',
              display: 'block'
            }}
          />
          <figcaption className='vdr-about-figcaption'>ISGT Europe · IEEE · Octubre 2024</figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Component06;
